import { render, staticRenderFns } from "./grade-distribute.vue?vue&type=template&id=e2bd33b4&scoped=true"
import script from "./grade-distribute.vue?vue&type=script&lang=js"
export * from "./grade-distribute.vue?vue&type=script&lang=js"
import style0 from "./grade-distribute.vue?vue&type=style&index=0&id=e2bd33b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bd33b4",
  null
  
)

export default component.exports